const n = (t) => !!new RegExp(
  "^((http|https)://)[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$"
).test(t);
export {
  n as isValidURL
};
//# sourceMappingURL=isValidUrl.es.js.map
